import {
    ComparatorPicker,
    ComparatorPickerBuilder,
    ComparatorPickerType,
    ComparisonOperator,
    Field,
    FieldType,
} from "../../vforms-model";
import { TextBox } from "../text-box/text-box";
import { ComparisonExpression } from "../../expression-settings/model";

export class ApiSelectSearchType extends FieldType {
    static Id = "api-select-search";

    constructor() {
        super();
        this.id = ApiSelectSearchType.Id;
        this.icon = "mat_outline:search";
        this.previewComponent = null;
        this.editorComponent = null;
    }

    createField(): Field {
        return new ApiSelectSearchField(this);
    }

    supportedComparisonOperators(): ComparisonOperator[] {
        return [...super.supportedComparisonOperators(), ComparisonOperator.Contains];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        let selection = [];
        if (value && typeof value === "string") {
            selection = JSON.parse(value);
        } else if (value) {
            selection = [...value];
        }

        switch (expression.operator) {
            case ComparisonOperator.Contains:
                return selection.findIndex((i) => i.startsWith(`${expression.value}:`)) >= 0;
        }

        return super.evaluate(expression, value);
    }
}

export class ApiSelectSearchField extends TextBox {
    constructor(type: FieldType) {
        super(type);
    }
}

export class ApiSelectSearchPickerBuilder extends ComparatorPickerBuilder {
    build(comparisonExpression: ComparisonExpression): ComparatorPicker {
        if (
            comparisonExpression.operator === ComparisonOperator.NotEmpty ||
            comparisonExpression.operator === ComparisonOperator.Empty
        ) {
            return new ComparatorPicker(ComparatorPickerType.None);
        }

        return new ComparatorPicker(ComparatorPickerType.Cid10Selection);
    }
}
